export const selectKeysToRemove = (keys: string[], keptKeys: string[] = []): string[] =>
  keys.filter(key => !keptKeys.includes(key));
